import { createSlice } from "@reduxjs/toolkit";

const agentSlice = createSlice({
  name: "agent",
  initialState: {
    agent: null,
    error: false,
    errorMessage: "",
  },
  reducers: {
    changeLoaderState: (state, action) => {
      state.loading = action.payload;
    },
    getAgentSuccess: (state, action) => {
      state.agentList = action.payload;
    },
    getAdminActionSuccess: (state, action) => {
      state.admin_actions = action.payload;
    },
    getAgentDetailsStart: (state, action) => {
      state.agent_details = {};
    },
    getAgentDetailsSuccess: (state, action) => {
      state.agent_details = action.payload;
    },
    getSelectedRoles: (state, action) => {
      state.selected_roles = action.payload;
    },
    getSelectedUsers: (state, action) => {
      state.selected_users = action.payload;
    },
  },
  selectors: {
    getAllAgentList: (state) => state.agentList ?? [],
    getAdminActions: (state) => state.admin_actions?.data ?? [],
    getAgentDetails: (state) => state.agent_details ?? {},
  },
});

export const {
  changeLoaderState,
  getAgentSuccess,
  getAdminActionSuccess,
  getAgentDetailsStart,
  getAgentDetailsSuccess,
  getSelectedRoles,
  getSelectedUsers
} = agentSlice.actions;
export const { getAllAgentList, getAdminActions, getAgentDetails } =
  agentSlice.selectors;
export default agentSlice.reducer;
